import React, { useRef, useState } from 'react';
import groupBy from 'lodash/groupBy';
import upperFirst from 'lodash/upperFirst';

import { useGlobalContext } from 'contexts/global-context';
import { useRouterContext } from 'contexts/router-context';
import useFixedScrollPositionOnPageChange from 'hooks/useFixedScrollPositionOnPageChange';
import useCustomHeaderOnScroll from 'hooks/useCustomHeaderOnScroll';
import useFixedBody from 'hooks/useFixedBody';
import Header from 'components/header';
import GenresFilter from 'components/genres-filter';
import GenreGames from 'components/genre-games';
import Section from 'components/section';
import { Genre, TGame } from 'types';

interface IGenres {
  parentRef: React.RefObject<any>;
  closeWithAnimation: () => void;
}

const Genres: React.FC<IGenres> = ({ parentRef, closeWithAnimation }) => {
  const { games } = useGlobalContext();
  const { currentRoute } = useRouterContext();
  const genre = currentRoute?.param as Genre | undefined;
  const headerRef = useRef<HTMLDivElement>(null);
  const [selectedGenre, setSelectedGenre] = useState<Genre | undefined>(genre);

  const filteredGames = games.filter((game: TGame) => !selectedGenre || game.genre === selectedGenre);
  const groupedGames = groupBy(filteredGames, (game: TGame) => game.genre);

  useFixedBody(true);

  useFixedScrollPositionOnPageChange(parentRef);

  useCustomHeaderOnScroll(parentRef, null, headerRef);

  return (
    <>
      <Header innerRef={headerRef} hideLogo onClick={closeWithAnimation} />
      <GenresFilter selected={selectedGenre} onClick={setSelectedGenre} />
      {!filteredGames.length && (
        <Section>
          <div>No games yet...wait a second and reload the page!</div>
        </Section>
      )}
      {Object.keys(groupedGames).map((genre: string) => (
        <Section key={genre} title={upperFirst(genre)}>
          <GenreGames noMoreLink genre={genre as Genre} games={groupedGames[genre]}/>
        </Section>
      ))}
    </>
  );
};

export default Genres;
